import { useTranslation } from "react-i18next";
import { Col, Form, Input, Layout, Popconfirm, Row, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TextEditor from "../../notifications/TextEditor";
import { SortableList } from "../../../components/SortableList";
import { FormInstance } from "antd/lib";
import "./privacy-policy.scss";

type PrivacyPolicyProps = {
  form: FormInstance;
  loading: boolean;
  allData: any;
};



const PrivacyPolicy = ({ allData, form, loading }: PrivacyPolicyProps) => {
  const { t } = useTranslation();
const validations = {
  name: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (value && value.length > 512) {
        return Promise.reject(
          new Error(t("Tên chính sách không vượt quá 512 ký tự", "Tên chính sách không vượt quá 512 ký tự"))
        );
      }
      if (!value) {
        return Promise.reject(new Error(t("Vui lòng nhập tên chính sách", "Vui lòng nhập tên chính sách")));
      }
      return Promise.resolve();
    },
  },
};
  const [activedItem, setActivedItem] = useState<any>();
  const [listData, setListData] = useState<any>([]);
  const [rowActive, setRowActive] = useState(0);
  const [countId, setCountId] = useState(0);

  // handle click row
  const handleActiveRow = (item: any, index: number) => {
    setActivedItem(item);
    setRowActive(index);
  };

  // handle add new
  const handleAddNew = () => {
    setListData((prevList: any) => [
      ...prevList,
      {
        id: `new-${countId}`,
        name: "",
        description: "",
      },
    ]);

    setCountId(countId + 1);
    form.setFieldValue(`name-new-${countId}`, null);
    form.setFieldValue(`description-new-${countId}`, null);
  };

  // handle delete
  const handleDelete = (id: string) => {
    const newList = listData.filter((item: any) => item.id !== id);
    setListData(newList);
  };

  // handle drag
  const handleDragChange = (values: any) => {
    setRowActive(0);
    setActivedItem(values[0]);
    setListData(values);
  };

  // useEffect
  useEffect(() => {
    const item = listData?.find(
      (item: any, index: number) => index === rowActive
    );
    setActivedItem(item);
  }, [rowActive]);

  useEffect(() => {
    if (allData && allData.length > 0) {
      const fields = allData.reduce((acc: any, item: any) => {
        acc[`name-${item.id}`] = item.name;
        acc[`description-${item.id}`] = item.description;
        return acc;
      }, {});

      form.setFieldsValue(fields);
    }
  }, [allData, form]);

  useEffect(() => {
    if (allData) {
      setListData(allData);
      setActivedItem(allData[0]);
      setRowActive(0);
      setCountId(allData.length);
    }
  }, [allData]);

  useEffect(() => {
    handleDragChange(listData);
  }, [listData]);

  return (
    <Layout className="page-header-group clause-layout">
      <Form form={form} name="publishPrivacyPolicy" style={{ width: "100%" }}>
        <Row gutter={16} className="privacy-policy-row">
          <Col
            className="privacy-policy-left-col"
            id="privacy-policy-left-col"
            xl={{ span: 6 }}
            md={{ span: 6 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <div className={`left-container`}>
              <Typography.Title
                level={4}
                style={{ marginBottom: 30, paddingLeft: 10 }}
              >
                {t("Danh sách chính sách", "Danh sách chính sách")}
              </Typography.Title>

              {loading ? (
                <Spin size="default" style={{width: "100%", marginTop: "25vh"}} />
              ) : (
                <div>
                  <div className="list-privacy-policy">
                    <SortableList
                      items={listData}
                      onChange={handleDragChange}
                      renderItem={(record: any, index: number) => (
                        <div onClick={() => {handleActiveRow(record, index);}} >
                          <SortableList.Item
                            id={record.id}
                            styles={{ backgroundColor: "transparent" }}
                          >
                            <SortableList.DragHandle />

                            <Form.Item
                              name={`name-${record.id ? record.id : `new-${index}`}`}
                              key={record.id}
                              style={{ width: "100%" }}
                              rules={[validations.name]}
                            >
                              <Input
                                className={`privacy-policy-item ${index === rowActive ? `active` : ""}`}
                                style={{ backgroundColor: "#fff", cursor: "text" }}
                              />
                            </Form.Item>
                            <Popconfirm
                              title={t("Xóa chính sách", "Xóa chính sách")}
                              description={t("Bạn chắc chắn muốn xóa chính sách này?", "Bạn chắc chắn muốn xóa chính sách này?")}
                              onConfirm={() => handleDelete(record.id)}
                              okText={t("Xóa", "Xóa")}
                              cancelText={t("Huỷ", "Huỷ")}
                            >
                              <a className="button-delete">
                                <DeleteOutlined />
                              </a>
                            </Popconfirm>
                          </SortableList.Item>
                        </div>
                      )}
                    />
                  </div>

                  <a
                    onClick={handleAddNew}
                    style={{
                      marginTop: 15,
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <PlusOutlined /> &nbsp; {t("Thêm mới", "Thêm mới")}
                  </a>
                </div>
              )}
            </div>
          </Col>
          <Col
            className="privacy-policy-right-col"
            xl={{ span: 18 }}
            md={{ span: 18 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <div className={`right-container`} id={`right-container`}>
              <Typography.Title level={4} style={{ marginBottom: 50 }}>
                {t("Nội dung chính sách", "Nội dung chính sách")}
              </Typography.Title>

              {loading ? (
                <Spin size="default" style={{width: "100%", marginTop: "23vh"}}/>
              ) : (
                <div className="privacy-policy-editor-content">
                  {listData?.map((item: any, index: number) => {
                    return (
                      <div className="card-description" hidden={item.id !== activedItem?.id} >
                        <Form.Item
                          name={`description-${item.id ? item.id : `new-${index}`}`}
                          style={{ backgroundColor: "#fff" }}
                        >
                          <TextEditor />
                        </Form.Item>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Form>
    </Layout>
  );
};

export default PrivacyPolicy;
